import { JournalStockField } from './types'

export interface DefaultBookingJournalProduct {
  productId: number

  /** Omitted for permanent products stored on customStockJournals / customStockActuals. */
  fieldKey?: JournalStockField
  label: string
}

/** Fabric ProductID for Beef Rib BBQ. Permanent Daily Stock row after Ground Beef (RN-2919). */
export const BEEF_RIB_BBQ_PRODUCT_ID = 10011918

/** Mirrors backend EON_BOOKING_JOURNAL_DEFAULT_PRODUCTS / product map. */
export const DEFAULT_BOOKING_JOURNAL_PRODUCTS: DefaultBookingJournalProduct[] = [
  { productId: 10000003, fieldKey: 'chicken', label: 'Chicken' },
  { productId: 10000002, fieldKey: 'beef', label: 'Beef' },
  { productId: 10000004, fieldKey: 'pork', label: 'Pork' },
  { productId: 10001142, fieldKey: 'groundBeef', label: 'Ground Beef' },
  { productId: BEEF_RIB_BBQ_PRODUCT_ID, label: 'Beef Rib BBQ' },
  { productId: 10000054, fieldKey: 'avocado', label: 'Avocado' },
  { productId: 10000064, fieldKey: 'tomato', label: 'Tomato' }
]

/** Permanent defaults with no dedicated SOH column. Always included in variance totals. */
export const PERMANENT_CUSTOM_DAILY_STOCK_PRODUCT_IDS = DEFAULT_BOOKING_JOURNAL_PRODUCTS.filter(
  product => product.fieldKey == null
).map(product => product.productId)

export const DEFAULT_BOOKING_JOURNAL_PRODUCT_IDS = DEFAULT_BOOKING_JOURNAL_PRODUCTS.map(p => p.productId)

const DEFAULT_PRODUCT_ID_SET = new Set(DEFAULT_BOOKING_JOURNAL_PRODUCT_IDS)

/** Pinned Daily Stock rows (Add row) — unique positive ints, never the permanent defaults. */
export function normalizeDailyStockPinnedProductIds(productIds: readonly unknown[] | null | undefined): number[] {
  if (!productIds?.length) return []

  const seen = new Set<number>()

  return productIds
    .map(id => Number(id))
    .filter(id => {
      if (!Number.isInteger(id) || id <= 0 || DEFAULT_PRODUCT_ID_SET.has(id)) {
        return false
      }
      if (seen.has(id)) return false
      seen.add(id)

      return true
    })
}
